import { useEffect, useCallback, useRef, useState } from 'react'
import { identity } from 'ramda'
import { useDispatch } from 'react-redux'

/* eslint-disable react-hooks/exhaustive-deps */
export const useEffectOnce = (fn, callback = identity) => {
  useEffect(() => {
    if (fn) {
      fn()
    }

    return callback
  }, [])
}

export const useMakeDispatchCallback = (action) => {
  const dispatch = useDispatch()
  return useCallback((...values) => dispatch(action(...values)), [action])
}

export const useActionCallback = (action, dispatch) => {
  return useCallback(
    (...values) => dispatch(action(...values)),
    [action, dispatch]
  )
}

export const usePrevious = (value) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

// react hook for setting and retrieving a key from local storage
export const useLocalStorage = (key, initialValue) => {
  const getValue = (key, fallback) => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : fallback
    } catch (error) {
      console.error(error)
    }
  }

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      console.error(error)
    }
  }

  const deleteValue = () => {
    try {
      setStoredValue(null)
      window.localStorage.removeItem(key)
    } catch (error) {
      console.error(error)
    }
  }

  const [storedValue, setStoredValue] = useState(() =>
    getValue(key, initialValue)
  )

  return [storedValue, setValue, deleteValue]
}
